import React from 'react';
import { useNavigate } from 'react-router-dom';
import SiteFooter from '../components/Footer';
import '../App.css';

const LearnMore: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="nf-home">
      {/* Hero Section */}
      <section className="nf-hero">
        <div className="nf-hero-content-bg">
          <h1>Learn More About NeutralFit</h1>
          <p>
            NeutralFit is an online golf fitting tool for all levels. We don’t push sponsored products—our recommendations are unbiased and data-driven.
          </p>
          <div className="nf-hero-buttons">
            <button
              onClick={() => navigate(window.innerWidth <= 768 ? '/club-fitting-mobile' : '/club-fitting')}
              className="nf-btn nf-btn-primary"
              style={{ whiteSpace: 'nowrap', fontSize: '16px', fontWeight: 'bold' }}
            >
              Try Club Fitting
            </button>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="nf-features nf-learn-section">
        <div className="container">
          <h2 className="nf-section-title">Why Choose NeutralFit?</h2>
          <ul className="nf-features-list nf-learn-list">
            <li>Unbiased, AI-powered recommendations</li>
            <li>Tools for all skill levels</li>
            <li>Personalized insights</li>
            <li>Free to use</li>
          </ul>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="nf-about nf-learn-section">
        <div className="container">
          <h2 className="nf-section-title">How It Works</h2>
          <ol className="nf-learn-steps">
            <li>Sign up and tell us about your golf experience.</li>
            <li>Our algorithm matches you with the best equipment for your needs.</li>
            <li>Get instant, unbiased recommendations—no sales pressure.</li>
          </ol>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
};

export default LearnMore;
